import { PanelStore } from '../interfaces';

export namespace SplitPaymentsSelectors {
  export const getLoading = (state: PanelStore.RootState) => {
    return state.splitPayments.loading;
  };
  export const getFormLoading = (state: PanelStore.RootState) => {
    return state.splitPayments.formLoading;
  };
  export const getError = (state: PanelStore.RootState) => {
    return state.splitPayments.error;
  };
  export const getErrorInfo = (state: PanelStore.RootState) => {
    return state.splitPayments.errorInfo;
  };
  export const getAllSplitPayments = (state: PanelStore.RootState) => {
    return state.splitPayments.allSplitPayments;
  };
  export const getRequestSuccess = (state: PanelStore.RootState) => {
    return state.splitPayments.requestSuccess;
  };
  export const getCollaboratorEmailValidated = (state: PanelStore.RootState) => {
    return state.splitPayments.collaboratorEmailValidated;
  };
  export const getCreateSplitPaymentPayload = (state: PanelStore.RootState) => {
    return state.splitPayments.createSplitPaymentPayload;
  };
  export const getStep = (state: PanelStore.RootState) => {
    return state.splitPayments.step;
  };
  export const getCollaborationIdSelected = (state: PanelStore.RootState) => {
    return state.splitPayments.collaborationIdSelected;
  };
  export const getUserType = (state: PanelStore.RootState) => {
    return state.splitPayments.createSplitPaymentPayload?.userType;
  };
  export const getExport = (state: PanelStore.RootState) => {
    return state.splitPayments.export;
  };
  export const getExportType = (state: PanelStore.RootState) => {
    return state.splitPayments.exportType;
  };
}
